import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {
  Box,
  Collapse,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  useTheme,
} from "@mui/material";
import { Autocomplete, Button, DateRangePicker, Toolbar } from "common";
import BoatCheckboxSelector from "components/BoatCheckboxSelector/BoatCheckboxSelector";
import ProgramCheckboxSelector from "components/ProgramCheckboxSelector/ProgramCheckboxSelector";
import useDictionaries from "features/dictionaries/useDictionaries";
import { useAdvancedReportContext } from "features/reports/AdvancedReport/useAdvancedReport";
import useSettings from "features/settings/useSettings";

export default function DynamicPricingReportFilter() {
  const { filter, setFilter, params, setParams } = useAdvancedReportContext();
  const { dictionaries } = useDictionaries();
  const theme = useTheme();
  const [settings, setSettings] = useSettings({ key: "advancedReport" });

  return (
    <Paper
      sx={{
        p: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
    >
      <DateRangePicker
        sx={{ width: 200 }}
        defaultRangeIdStorageKey="dynamicPricingReportDateRange"
        value={{ from: filter.from, to: filter.to }}
        onChange={range => setFilter({ ...filter, ...(range as any) })}
      />
      <Toolbar sx={{ alignSelf: "stretch", gap: 2, flexWrap: "wrap" }}>
        <FormControl sx={{ flex: 1, minWidth: 200 }}>
          <InputLabel>Csoportosítás</InputLabel>
          <Select
            value={params.groupBy}
            label="Csoportosítás"
            onChange={event =>
              setParams({
                ...params,
                groupBy: event.target.value as any,
              })
            }
          >
            <MenuItem value="program">Program</MenuItem>
            <MenuItem value="program_variant">Programtípus</MenuItem>
            <MenuItem value="partner">Partner</MenuItem>
            <MenuItem value="partner_group">Partnercsoport</MenuItem>
            <MenuItem value="boat">Hajó</MenuItem>
            <MenuItem value="time">Időpont</MenuItem>
          </Select>
        </FormControl>
        <Autocomplete
          sx={{ flex: 1, minWidth: 200 }}
          label="Partnerek"
          multiple
          options={dictionaries.partners}
          value={filter.partnerIds}
          onChange={(event: any) =>
            setFilter({ ...filter, partnerIds: event.target.value })
          }
        />
        <Autocomplete
          sx={{ flex: 1, minWidth: 200 }}
          label="Partner csoportok"
          multiple
          options={dictionaries.partnergroups}
          value={filter.partnerGroupIds}
          onChange={(event: any) =>
            setFilter({ ...filter, partnerGroupIds: event.target.value })
          }
        />
      </Toolbar>
      <Button
        variant="text"
        size="small"
        endIcon={settings.show_filter ? <ExpandLess /> : <ExpandMore />}
        title={settings.show_filter ? "Szűrő elrejtése" : "Szűrő mutatása"}
        onClick={() => setSettings({ show_filter: !settings.show_filter })}
      />
      <Collapse in={settings.show_filter} sx={{ width: "100%" }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, py: 1.5 }}>
          <BoatCheckboxSelector
            color={theme.palette.primary.main}
            value={filter.boatIds || []}
            onChange={event =>
              setFilter({
                ...filter,
                boatIds: (event.target?.value || []) as any,
              })
            }
          />
          <ProgramCheckboxSelector
            includeInactive
            value={filter.programIds || []}
            onChange={event =>
              setFilter({
                ...filter,
                programIds: (event.target?.value || []) as any,
              })
            }
            showMore={settings.show_all_programs}
            setShowMore={showAll => setSettings({ show_all_programs: showAll })}
          />
        </Box>
      </Collapse>
    </Paper>
  );
}
